export default function(gantt) {
	gantt.config.auto_scheduling_use_progress = false;
	gantt.config.auto_scheduling_project_constraint = false;

};

